import { render, staticRenderFns } from "./download-page.vue?vue&type=template&id=4a4e4c6f"
import script from "./download-page.vue?vue&type=script&lang=js"
export * from "./download-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports